'use strict';
var moment = (typeof window !== "undefined" ? window.moment : typeof global !== "undefined" ? global.moment : null);

function dateTimeUtility(moment) {
	var iso8601Format = 'YYYY-MM-DDTHH:mm:ss[Z]';

	function parseIso8601(date) {
		var parsed = moment(date, iso8601Format, true);
		return parsed.isValid() ? parsed : null;
	}

	function toIso8601(date) {
		return moment(date).utc().format(iso8601Format);
	}

	function differenceInSeconds(date1, date2) {
		return moment(date1).diff(moment(date2), 'seconds');
	}

	return {
		parseIso8601: parseIso8601,
		toIso8601: toIso8601,
		differenceInSeconds: differenceInSeconds
	};
}

module.exports = dateTimeUtility(moment);